import React from 'react';
import { ShowButton, Datagrid, TextField, DateField, Filter, TextInput, SelectInput, DateInput } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import TList from '../../components/wrapper/TList';
import { paymentStatusForSelection, paymentTypesForSelection } from './PaymentConstants';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import PaymentListActions from './PaymentListActions';

const PaymentFilter = props => (
	<Filter {...props}>
		<SelectInput alwaysOn="true" source="paymentType" choices={paymentTypesForSelection} />
		<SelectInput alwaysOn="true" source="paymentStatus" choices={paymentStatusForSelection} />
		<DateInput
			alwaysOn
			source="fromDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			alwaysOn
			source="untilDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<TextInput alwaysOn="true" source="paymentMethod" resettable />
	</Filter>
);

const PaymentList = props => (
	<TList
		{...props}
		sort={{ field: 'id', order: 'DESC' }}
		actions={<PaymentListActions />}
		filters={<PaymentFilter />}
		>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<DateField source="creationDateTime" showTime />
			<AmountField source="amount" sortable={false} />
			<TextField source="paymentType" />
			<TextField source="paymentStatus" />
			<TextField source="paymentSettlementStatus" sortable={false} />
			<TextField source="description" sortable={false} />
			<TextField source="paymentMethod" sortable={false} />
		</Datagrid>
	</TList>
);

export default PaymentList;
